import React, { useEffect, useState, useRef, Suspense } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import loadable from "@loadable/component";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { Auth } from "aws-amplify";

import { setAuthenticated, onLoad, setPreviousPath, setChannelBackPath, toggleLoading, setError, setNow, clearStreamVod, setModal, setStreamVod, setSubscriptionBackPath, setSportsBackPath } from './actions';
import { loginCheck, refreshToken, loginProfileLoad, guideRefresh, setDetailSkip, resetParental } from '../redux-root/actions';
import usePrevious from '../utils/usePrevious';
import gtmHelper from '../utils/gtmHelper';
import ratingJson from '../config/rating.json';

import styles from './index.module.css';

import LoadingPage from '../page/Loading';
import AnimationPage from '../page/Animation';
import ErrorPage from '../page/Error';
import Modal from '../components/Modal';
import PinOverlay from '../page/Parental/PinOverlay';

import NavigationMenu from '../components/Menu';
import NavigationMobileMenu from '../components/NavigationMobileMenu';
const LoginPage = React.lazy(() => import("../page/Login"));
const HomePage = React.lazy(() => import('../page/Home'));
const SearchPage = React.lazy(() => import('../page/Search'));
const DetailsPage = React.lazy(() => import('../page/Details'));
const OnDemandPage = React.lazy(() => import('../page/OnDemand'));
const FavouritePage = React.lazy(() => import("../page/Favourite"));
const SubscriptionsPage = React.lazy(() => import("../page/Subscriptions"));
const SubscriptionsDetailPage = React.lazy(() => import("../page/SubscriptionsDetail"));
const WatchHistoryPage = React.lazy(() => import("../page/WatchHistory"));
const VodPlayer = React.lazy(() => import('../page/Player/Vod'));
const LivePlayer = React.lazy(() => import('../page/Player/Live'));
const AboutUsPage = React.lazy(() => import("../page/AboutUs"));
const AccountDetailPage = React.lazy(() => import("../page/AccountDetail"));
const ParentalControlPage = React.lazy(() => import("../page/Parental"));
const GuidePage = React.lazy(() => import('../page/Guide'));
const SetupPage = React.lazy(() => import("../page/Setup"));
const LinkPage = React.lazy(() => import("../page/Link"));
const TermsPage = React.lazy(() => import("../page/Terms"));
const DRPage = React.lazy(() => import('../page/DR'));
const LanguagesPage = React.lazy(() => import("../page/Languages"));
const SportsPage = React.lazy(() => import("../page/Sports"));
const SportsDetailPage = React.lazy(() => import("../page/SportsDetail"));
const RecordingPage = React.lazy(() => import("../page/Recording"));

let refreshInterval;
let gtmObj = {};

const isTouchScreen = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
const refreshTokenBool = localStorage.getItem("_r");

function App(props) {
  const { authenticated, initialLoad, loading, error, animation, menuCollapsed, streamVod, modal, channelData, profileLoaded, profileData, skipStep, showTerms, hashUserId, drMode, config, tvMode, bizMode, bizLoginData, detailSkip, contentDetails, pinCheck, restartParental } = props;

  const [preLoading, setPreLoading] = useState(false);
  const [scrollHidden, setScrollHidden] = useState(false);
  const [refreshLoading, setRefreshLoading] = useState(false);
  const [streamLoading, setStreamLoading] = useState(false);
  const [minMenu, setMinMenu] = useState(false);
  const [backStatus, setBackStatus] = useState(false);
  const [timeoutData, _setTimeoutData] = useState(null);
  const timeoutDataRef = useRef(timeoutData);
  const setTimeoutData = (data) => {
    timeoutDataRef.current = data;
    _setTimeoutData(data);
  };
  const [parental, _setParental] = useState(false);
  const parentalRef = useRef(parental);
  const setParental = (data) => {
    parentalRef.current = data;
    _setParental(data);
  };
  const [submitFunc, setSubmitFunc] = useState(() => {});
  const [parentalDisplay, _setParentalDisplay] = useState(false);
  const parentalDisplayRef = useRef(parentalDisplay);
  const setParentalDisplay = (data) => {
    parentalDisplayRef.current = data;
    _setParentalDisplay(data);
  };

  const navigateTo = useNavigate();
  const location = useLocation();
  const previousAuth = usePrevious(authenticated);
  const previousInitialLoad = usePrevious(initialLoad);
  const previousProfileLoaded = usePrevious(profileLoaded);
  const previousLocation = usePrevious(location);
  const prevStream = usePrevious(streamVod);
  const prevProfileData = usePrevious(profileData);
  const prevContentDetails = usePrevious(contentDetails);
  const prevRestartParental = usePrevious(restartParental);

  useEffect(() => {
    if (window.tizen && window.tizen.tvinputdevice) {
      window.tizen.tvinputdevice.registerKey('MediaPlay');
      window.tizen.tvinputdevice.registerKey('MediaPause');
      window.tizen.tvinputdevice.registerKey('ChannelUp');
      window.tizen.tvinputdevice.registerKey('ChannelDown');
    }

    props.onLoad(bizMode);

    if (!refreshTokenBool) {
      navigateTo('/login');
    } else if (
      location.pathname === '/index.html' ||
      location.pathname === '/login' ||
      location.pathname === '/setup' ||
      location.pathname === '/link' ||
      location.pathname === '/terms'
    ) {
      navigateTo('/');
    }

    window.onpopstate = () => {
      // window.location.reload(false); // DISABLE REFRESH

      const currentLocation = window.location;

      if (!localStorage.getItem("_r")) {
        navigateTo('/login');
      } else if (
        currentLocation.pathname === '/index.html' ||
        currentLocation.pathname === '/login' ||
        currentLocation.pathname === '/setup' ||
        currentLocation.pathname === '/link' ||
        currentLocation.pathname === '/terms'
      ) {
        navigateTo('/');
      }

      setBackStatus(true);
      props.setModal(null);
      props.clearStreamVod();
    }

    return () => {
      if (window.tizen && window.tizen.tvinputdevice) {
        window.tizen.tvinputdevice.unregisterKey('MediaPlay');
        window.tizen.tvinputdevice.unregisterKey('MediaPause');
        window.tizen.tvinputdevice.unregisterKey('ChannelUp');
        window.tizen.tvinputdevice.unregisterKey('ChannelDown');
      }
    }
    /* eslint-disable */
  }, []);

  useEffect(() => {
    if (previousAuth !== authenticated && authenticated) {
      if (location.pathname === "/login" || location.pathname === '/setup') {
        navigateTo('/');
      }

      setPreLoading(true);

      if (initialLoad) {
        props.loginProfileLoad(channelData.freeChannel);

        if (!tvMode) {
          document.addEventListener('visibilitychange', checkVisibility);
        }
      }
    }

    return () => {
      if (!tvMode) {
        document.removeEventListener('visibilitychange', checkVisibility);
      }
    }
    /* eslint-disable */
  }, [authenticated]);

  useEffect(() => {
    if (previousInitialLoad !== initialLoad && initialLoad) {
      refreshInterval = setInterval(() => {
        const newNow = new Date();
        const nowDate = newNow.getTime();

        const tokenDataJson = JSON.parse(localStorage.getItem('_td'));
        let expiryDate;

        if (tokenDataJson && tokenDataJson.expiresIn) {
          expiryDate = tokenDataJson.expiresIn;
        }

        if (bizMode && tokenDataJson && nowDate >= expiryDate) {
          const timeoutModalData = timeoutDataRef.current;

          props.clearStreamVod();
          props.setAuthenticated(false);
          navigateTo('/login');

          localStorage.removeItem('_r');
          localStorage.removeItem('_td');

          props.setModal(
            timeoutModalData.title,
            timeoutModalData.description,
            timeoutModalData.buttonText,
            () => timeoutModalData.url ? window.open(timeoutModalData.url) : {},
            '',
            '',
            '',
            '',
            timeoutModalData.code
          );
        }

        if (newNow.getHours() === 0 && newNow.getMinutes() === 0) {
          props.guideRefresh();
        }

        props.setNow(newNow);
      }, 60000);

      if (refreshTokenBool) {
        setPreLoading(true);

        if (!bizMode) {
          Auth.currentSession()
            .then(ses => {
              // console.log('Cognito Token refreshed');

              props.loginCheck(ses.accessToken.jwtToken, true);
              props.setAuthenticated(true);
            })
            .catch(err => {
              console.log(err);

              navigateTo('/login'); // TV ONLY (MAYBE)
              Auth.signOut();
              setPreLoading(false);

              localStorage.removeItem('_r');
            });
        } else {
          const nowDate = new Date().getTime();

          const tokenDataJson = JSON.parse(localStorage.getItem('_td'));
          let expiryDate;

          if (tokenDataJson && tokenDataJson.expiresIn) {
            expiryDate = tokenDataJson.expiresIn;
          }

          if (tokenDataJson && nowDate < expiryDate) {
            props.loginCheck(tokenDataJson.accessToken, true);
            props.setAuthenticated(true);
          } else {
            navigateTo('/login');
            setPreLoading(false);

            localStorage.removeItem('_r');
          }
        }
      } else if (authenticated) {
        props.loginProfileLoad(channelData.freeChannel);
      }
    }

    return () => {
      clearInterval(refreshInterval);
    }
    /* eslint-disable */
  }, [initialLoad]);

  useEffect(() => {
    if (previousProfileLoaded !== profileLoaded && profileLoaded) {
      setPreLoading(false); // JUST TO LET OTHER PAGES LOAD AFTER LOGIN CHECK

      if (!tvMode && !skipStep && !config.setting.skipSetup) {
        navigateTo('/link');
      } else if (showTerms && !bizMode) {
        navigateTo('/terms');
      }
    }
    /* eslint-disable */
  }, [profileLoaded]);

  useEffect(() => {
    if (!menuCollapsed || tvMode) {
      setScrollHidden(true);
    } else {
      setScrollHidden(false);
    }
    /* eslint-disable */
  }, [menuCollapsed]);

  useEffect(() => {
    if (previousLocation !== undefined && previousLocation.pathname !== location.pathname) {
      setRefreshLoading(true);

      if (location.pathname.includes('/movie') || location.pathname.includes('/show')) {
        props.setPreviousPath(previousLocation.pathname);
      } else {
        props.setPreviousPath(null);
      }

      if (
        !location.pathname.includes('/movie') &&
        !previousLocation.pathname.includes('/movie') &&
        !location.pathname.includes('/show') &&
        !previousLocation.pathname.includes('/show')
      ) {
        if (location.pathname.includes('/subscriptions/')) {
          props.setSubscriptionBackPath(previousLocation.pathname);
        } else {
          props.setSubscriptionBackPath(null);
        }

        if (location.pathname.includes('/sports/')) {
          props.setSportsBackPath(previousLocation.pathname);
        } else {
          props.setSportsBackPath(null);
        }
      }

      if (location.pathname.includes('/channel') && !previousLocation.pathname.includes('/channel')) {
        props.setChannelBackPath(previousLocation.pathname);
      } else if (previousLocation.pathname.includes('/channel') && !location.pathname.includes('/channel')) {
        props.setChannelBackPath(null);
      }

      if (authenticated && !bizMode) {
        Auth.currentSession()
          .then(ses => {
            props.refreshToken(ses.accessToken.jwtToken);
            setRefreshLoading(false);
          })
          .catch(err => {
            Auth.signOut();
            props.setAuthenticated(false);
            navigateTo('/login'); // TV ONLY (MAYBE)

            localStorage.removeItem('_r');
            setRefreshLoading(false);
          })
      } else {
        setTimeout(() => {
          setRefreshLoading(false);
        }, 500);
      }
    }
    /* eslint-disable */
  }, [location]);

  useEffect(() => {
    if (prevStream !== undefined && prevStream !== streamVod) {
      setStreamLoading(true);

      if (authenticated && !bizMode) {
        Auth.currentSession()
          .then(ses => {
            props.refreshToken(ses.accessToken.jwtToken);
            setStreamLoading(false);
          })
          .catch(err => {
            Auth.signOut();
            props.setAuthenticated(false);
            navigateTo('/login'); // TV ONLY (MAYBE)

            localStorage.removeItem('_r');
            setStreamLoading(false);
          })
      } else {
        setTimeout(() => {
          setStreamLoading(false);
        }, 500);
      }
    }
    /* eslint-disable */
  }, [streamVod]);

  useEffect(() => {
    if (window.innerWidth < 1024) {
      setMinMenu(true);
    }
  /* eslint-disable */
  }, [minMenu]);

  useEffect(() => {
    if (backStatus) {
      props.setError(null);

      setTimeout(() => {
        setBackStatus(false);
      }, 200);
    }
  /* eslint-disable */
  }, [backStatus, error]);

  useEffect(() => {
    if (drMode) {
      navigateTo('/');
    }
  /* eslint-disable */
  }, [drMode]);

  useEffect(() => {
    if (prevProfileData !== profileData && profileData && bizMode) {
      const finalPromoData = bizLoginData ? bizLoginData : profileData;

      if (finalPromoData) {
        setTimeoutData({
          title: 'Thanks for watching!',
          description: finalPromoData.promoDescription,
          code: finalPromoData.promoCode ? finalPromoData.promoCode : '',
          url: finalPromoData.promoCode ? finalPromoData.promoUrl : '',
          buttonText: finalPromoData.promoCode ? 'Redeem Now' : ''
        });
      }
    }
    /* eslint-disable */
  }, [profileData]);

  useEffect(() => {
    if (detailSkip && contentDetails && JSON.stringify(prevContentDetails) !== JSON.stringify(contentDetails)) {
      if (detailSkip.showId) {
        toggleParentalDisplay(() => props.setStreamVod(detailSkip, `/shows/episodes/${detailSkip.id}`));
      } else {
        toggleParentalDisplay(() => props.setStreamVod(detailSkip, `/movies/${detailSkip.id}`));
      }

      props.setDetailSkip(null);
    }
    /* eslint-disable */
  }, [detailSkip, contentDetails]);

  useEffect(() => {
    if (prevRestartParental !== restartParental && prevRestartParental !== undefined && restartParental) {
      if (streamVod && !location.pathname.includes('/channel/')) {
        toggleParentalDisplay(() => props.setStreamVod(streamVod.data, streamVod.url));
      }
    }
    /* eslint-disable */
  }, [restartParental]);

  const logoutClick = () => {
    props.toggleLoading();

    gtmObj.category = 'watchcast-logout';
    gtmObj.userId = hashUserId;

    gtmHelper({
      ...gtmObj,
      section: 'authentication',
      subSection: 'are-you-sure-you-want-to-logout?',
      action: 'button-click',
      label: 'yes',
      componentType: 'logout-pop-up'
    });

    Auth.signOut();
    props.setAuthenticated(false);
    navigateTo('/login');
  }

  const checkVisibility = () => {
    const loadDate = new Date(localStorage.getItem('_et'));
    const nowDate = new Date();

    if (!document.hidden) {
      if (nowDate.getDate() !== loadDate.getDate()) {
        props.guideRefresh();
      }
    }
  }

  const toggleParentalDisplay = (func) => {
    if (authenticated) {
      if (profileData.parental) {
        const contentRatingIndex = ratingJson.parental.indexOf(contentDetails.contentRating);
        const userRatingIndex = ratingJson.parental.indexOf(profileData.parental.contentRating);

        if ((contentRatingIndex !== -1 && userRatingIndex !== -1 && contentRatingIndex <= userRatingIndex) && !pinCheck) {
          if (profileData.parental.pinEnabled) {
            setParentalDisplay(!parentalDisplay);
            setSubmitFunc(() => func);
          } else {
            props.setModal('Parental Control', 'Set up your PIN');
          }
        } else {
          func();
        }
      } else {
        func();
      }
    } else {
      func();
    }
  }

  let showMenu = false;

  if (location.pathname !== '/login' && location.pathname !== '/setup' && location.pathname !== '/link' && location.pathname !== '/terms') {
    showMenu = true;
  }

  return (
    <div className={styles['wrapper']}>
      {
        drMode ?
          <Suspense fallback={<LoadingPage />}>
            <div className={styles['page']}>
              <DRPage />
            </div>
          </Suspense>
          :
          !preLoading && !refreshLoading ?
            <Suspense fallback={<LoadingPage />}>
              <div className={styles['page-wrapper']}>
                {
                  showMenu && !loading ?
                    !minMenu ?
                      <NavigationMenu />
                      :
                      <NavigationMobileMenu logoutClick={logoutClick} />
                    :
                    ""
                }

                <div className={`${styles['page']} ${location.pathname === '/login' ? styles['login-mode'] : ""} ${scrollHidden ? styles['scroll-hidden'] : ""} ${!showMenu && isTouchScreen ? styles['mobile-full'] : ""}`} id="app-page">
                  {
                    initialLoad ?
                      <Routes>
                        <Route path="/login" element={<LoginPage />} />

                        <Route path="/setup" element={<SetupPage />} />
                        <Route path="/link" element={<LinkPage />} />
                        <Route path="/terms" element={<TermsPage />} />

                        <Route path="/" element={<HomePage blockFocus={parentalDisplay} />} />
                        <Route path="/search" element={<SearchPage />} />
                        <Route path="/ondemand" element={<OnDemandPage />} />} />
                        <Route path="/guide" element={<GuidePage />} />
                        <Route path="/sports" element={<SportsPage />} />
                        <Route path="/sports/:id" element={<SportsDetailPage />} />

                        <Route path="/favourite" element={<FavouritePage logoutClick={logoutClick} />} />
                        <Route path="/subscriptions" element={<SubscriptionsPage logoutClick={logoutClick} />} />
                        <Route path="/subscriptions/:id" element={<SubscriptionsDetailPage logoutClick={logoutClick} />} />
                        <Route path="/watch-history" element={<WatchHistoryPage logoutClick={logoutClick} />} />
                        <Route path="/about-us" element={<AboutUsPage logoutClick={logoutClick} />} />
                        <Route path="/account-details" element={<AccountDetailPage logoutClick={logoutClick} />} />
                        <Route path="/parental-control" element={<ParentalControlPage logoutClick={logoutClick} />} />
                        <Route path="/languages" element={<LanguagesPage logoutClick={logoutClick} />} />
                        <Route path="/recordings" element={<RecordingPage logoutClick={logoutClick} />} />

                        <Route path="/show/:id" element={<DetailsPage />} />
                        <Route path="/movie/:id" element={<DetailsPage />} />
                        <Route path="/channel/:id" element={<LivePlayer />} />

                        <Route path="*" element={<Navigate to="/" />} />
                      </Routes>
                      :
                      config ?
                        <Routes>
                          <Route path="/login" element={<LoginPage />} />
                          <Route path="/setup" element={<SetupPage />} />
                        </Routes>
                        :
                        ""
                  }

                </div>

                {
                  streamVod && !streamLoading ?
                    <VodPlayer />
                    :
                    ""
                }
              </div>
            </Suspense>
            :
            ""
      }

      {
        modal ?
          <Modal />
          :
          ""
      }

      {
        parentalDisplay ?
          <PinOverlay
            onBack={() => setParentalDisplay(false)}
            onSubmit={() => {
              setParentalDisplay(false);
              submitFunc();
            }}
          />
          :
          ""
      }

      {loading || refreshLoading || streamLoading || (!initialLoad && !drMode && (location.pathname !== '/login' && location.pathname !== '/setup')) ? <LoadingPage /> : ""}

      {
        animation ?
          <AnimationPage />
          : ""
      }

      {
        error ?
          <ErrorPage />
          : ""
      }
    </div>
  );
}

const mapStateToProps = (state) => ({
  authenticated: state.app.authenticated,
  initialLoad: state.app.initialLoad,
  loading: state.app.loading,
  error: state.app.error,
  animation: state.app.animation,
  modal: state.app.modal,
  menuCollapsed: state.menu.menuCollapsed,
  streamVod: state.app.streamVod,
  channelData: state.app.channelData,
  profileLoaded: state.app.profileLoaded,
  profileData: state.app.profileData,
  skipStep: state.app.skipStep,
  showTerms: state.app.showTerms,
  hashUserId: state.app.hashUserId,
  drMode: state.app.drMode,
  drLoading: state.app.drLoading,
  config: state.app.config,
  tvMode: state.app.tvMode,
  bizMode: state.app.bizMode,
  bizLoginData: state.login.bizLoginData,
  detailSkip: state.details.detailSkip,
  contentDetails: state.details.contentDetails,
  pinCheck: state.parental.pinCheck,
  restartParental: state.parental.restartParental
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setAuthenticated,
      onLoad,
      loginCheck,
      refreshToken,
      setPreviousPath,
      setChannelBackPath,
      toggleLoading,
      loginProfileLoad,
      setError,
      guideRefresh,
      setNow,
      setModal,
      clearStreamVod,
      setDetailSkip,
      setStreamVod,
      setSubscriptionBackPath,
      setSportsBackPath,
      resetParental
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(App);
